import { container } from "../../assets/jss/dibots-global-style";

const signupPageStyle = {
    container: {
        ...container,
        zIndex: "3",
        position: "relative",
        // paddingTop: "25vh",
        color: "#FFFFFF",
        // "@media (max-width: 480px)": {
        //     paddingTop: "18vh"
        // },
        padding: "0px",
        margin: "60px 0px 0px",
        // height: "100vh"
    },
    gridContainer: {
        margin: "auto",
        position: "absolute",
        top: "0",
        bottom: "0",
        height: "fit-content",
    },
    cardHidden: {
        opacity: "0",
        transform: "translate3d(0, -60px, 0)"
    },
    pageHeader: {
        minHeight: "100vh",
        height: "auto",
        display: "inherit",
        position: "relative",
        margin: "0",
        padding: "0",
        border: "0",
        alignItems: "center",
        // "&:before": {
        //     background: "rgba(0, 0, 0, 0.5)"
        // },
        "&:before,&:after": {
            position: "absolute",
            zIndex: "1",
            width: "100%",
            height: "100%",
            display: "block",
            left: "0",
            top: "0",
            content: '""'
        },
        "& footer li a,& footer li a:hover,& footer li a:active": {
            color: "#FFFFFF"
        },
        "& footer": {
            position: "absolute",
            bottom: "0",
            width: "100%"
        }
    },
    form: {
        margin: "0"
    },
    darkCard: {
        background: "#121212 !important",
        color: "white !important",
        boxShadow: "0 2px 2px 0 rgb(255 255 255 / 14%), 0 3px 1px -2px rgb(255 255 255 / 20%), 0 1px 5px 0 rgb(255 255 255 / 12%)",
        "& button": {
            color: "white"
        }
    },
    cardHeader: {
        width: "auto",
        textAlign: "center",
        marginLeft: "20px",
        marginRight: "20px",
        marginTop: "-40px",
        padding: "20px 0",
        marginBottom: "15px",
        "@media (max-width: 480px)": {
            padding: "10px"
        }
    },
    socialIcons: {
        maxWidth: "24px",
        marginTop: "0",
        width: "100%",
        transform: "none",
        left: "0",
        top: "0",
        height: "100%",
        lineHeight: "41px",
        fontSize: "20px"
    },
    divider: {
        marginTop: "30px",
        marginBottom: "0px",
        textAlign: "center"
    },
    cardFooter: {
        padding: "0rem",
        border: "0",
        borderRadius: "6px",
        justifyContent: "center !important"
    },
    socialLine: {
        marginTop: "1rem",
        textAlign: "center",
        padding: "0"
    },
    inputIconsColor: {
        color: "#495057"
    },
    progress: {
        margin: "10px 0px 14px",
        color: "#003663"
    },
    dialogPaper: {
        minWidth: '80%',
        maxWidth: '80%'
    },

    darkTheme: {
        background: "#121212 !important",
        color: "white !important",
        // "& input, & input::placeholder, & label, & svg, & span": {
        //     color: "white !important"
        // }
        // "& svg, & span": {
        //     color: "white !important"
        // }
        "& button": {
            color: "white"
        }
    },

    dateOfBirthContainer: {
        marginTop: "9px",
        width: "100%",
        "& button.MuiIconButton-root": {
            padding: "0px"
        },
    },
    darkDateOfBirthContainer: {
        "& .MuiInput-underline": {
            "&:hover:not($disabled):before,&:before": {
                borderColor: "#FFFFFF"
            },
            "&:after": {
                borderColor: "#FFFFFF"
            }
        }
    },

    phoneLightTheme: {
        margin: "20px 0px 2px",
        "& select, & input, & input::placeholder": {
            background: "white",
            color: "black"
        }
    },
    phoneDarkTheme: {
        margin: "20px 0px 2px",
        "& select, & input, & input::placeholder": {
            background: "#121212",
            color: "white"
        }
    },
    phoneSuccess: {
        "& select, & input, & input::placeholder": {
            color: "#4caf50",
            borderColor: "#4caf50"
        }
    },

    agreementCheck: {
        margin: "auto auto auto -8px",
        fontWeight: "bold",
        color: "#378ad3",
        textDecoration: "underline",
        cursor: "pointer"
    },

    errorMsg: {
        color: "red",
        fontSize: "10px",
        marginLeft: "37px"
    },
    normalErrorMsg: {
        color: "red",
        fontSize: "10px",
    },
    helperText: {
        fontSize: "10px",
        marginLeft: "37px"
    },
    greenHelperText: {
        color: "#4caf50"
    },
    normalHelperText: {
        fontSize: "10px"
    },


    formControl: {
        "& select": {
            fontSize: "14px !important",
            padding: "0px 24px 0px 0px !important",
            fontWeight: "bold"
        }
    },
    darkFormControl: {
        "& label, select, svg": {
            color: "white",
        },
        "& .Mui-focused": {
            color: "white",
            "&::after": {
                borderBottom: "2px solid rgba(255, 255, 255, 0.87)"
            }
        }
    },
    selectClass: {
        marginTop: "6px !important", 
        fontSize: "14px",
        "& select": {
            paddingTop: "4px",
            paddingBottom: "2px"
        }
    },
    darkSelectClass: {
        "&:hover:not(.Mui-disabled):before, :focus:not(.Mui-disabled):before": {
            borderBottom: "1px solid rgba(255, 255, 255, 0.87)"
        },
        "&::before": {
            borderBottom: "1px solid rgba(255, 255, 255, 0.42)"
        },
        "& .MuiSelect-select:not([multiple]) option, .MuiSelect-select:not([multiple]) optgroup": {
            backgroundColor: "#121212",
            color: "white"
        }
    },
};

export default signupPageStyle;
